export const DEFAULT_LANGUAGE = 'jp'
export const AJAX_DEFAULT_TIMEOUT = 3600 * 1000 // 60 minute

export const Category = {
  NAVI: 'NAVI',
  CLF: 'CLF',
  REG: 'REG',
  TSA: 'TSA',
  DL: 'DL',
  UNS: 'UNS'
}

export const DefaultAlgorithm = {
  CLF: 'AutomatedClassifier',
  REG: 'AutomatedRegressor',
  TSA: 'ProphetLearner',
  UNS: 'KMeansLearner'
}

export const InformationImportance = {
  HIGH: 10,
  MIDDLE: 20,
  LOW: 30
}



// WEBPACK FOOTER //
// ./src/defines/const.js